import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

function Footer() {
    const { isEnLang } = useLanguage();

    const t = isEnLang
        ? {
            tagline: "Hospitality and elegance on the Lazio coast, between Anzio and Nettuno.",
            checkIn: "Check-in",
            checkOut: "Check-out",
            checkInTime: "from 14:00",
            checkOutTime: "by 11:00",
            usefulLinks: "Quick Links",
            rights: "© 2026 Alma Suite B&B. All rights reserved.",
            rooms: "Rooms",
            jacuzzi: "Jacuzzi Suite",
            services: "Services",
            contact: "Contact",
            breakfast: "Breakfast",
            location: "Location",
          }
        : {
            tagline: "Accoglienza ed eleganza sulla costa laziale, tra Anzio e Nettuno.",
            checkIn: "Check-in",
            checkOut: "Check-out",
            checkInTime: "dalle 14:00",
            checkOutTime: "entro le 11:00",
            usefulLinks: "Link Rapidi",
            rights: "© 2026 Alma Suite B&B. Tutti i diritti riservati.",
            rooms: "Camere",
            jacuzzi: "Suite Jacuzzi",
            services: "Servizi",
            contact: "Contatti",
            breakfast: "Colazione",
            location: "Dove Siamo",
          };

    return (
        <footer className="footer">
            <div className="footer-content l-1260">
                <div className="footer-col">
                    <h3>B&amp;B Alma Suite</h3>
                    <p>{t.tagline}</p>
                    <p>Via Albenga 3/5, Nettuno (RM)</p>
                    <p className="footer-codes">
                        <strong>CIR</strong>: 058072-B&amp;B-00019<br />
                        <strong>CIN</strong>: IT058072C15JSP875V
                    </p>
                </div>
                <div className="footer-col">
                    <h3>{t.checkIn} / {t.checkOut}</h3>
                    <p>{t.checkIn}: <strong style={{ color: 'rgba(255,255,255,0.75)' }}>{t.checkInTime}</strong></p>
                    <p>{t.checkOut}: <strong style={{ color: 'rgba(255,255,255,0.75)' }}>{t.checkOutTime}</strong></p>
                </div>
                <div className="footer-col">
                    <h3>{t.usefulLinks}</h3>
                    <ul className="footer-links">
                        <li><Link to="/camere">{t.rooms}</Link></li>
                        <li><Link to="/suite-jacuzzi">{t.jacuzzi}</Link></li>
                        <li><Link to="/colazione">{t.breakfast}</Link></li>
                        <li><Link to="/dove-siamo">{t.location}</Link></li>
                        <li><a href="/#services">{t.services}</a></li>
                        <li><a href="/#contact">{t.contact}</a></li>
                    </ul>
                </div>
            </div>
            <div className="footer-bottom">
                <p>{t.rights}</p>
            </div>
        </footer>
    );
}

export default Footer;
